import { LanguagePreferences } from './user';

export type ValidateAdminCode = {
  isCodeValid: boolean;
  isAllowedToRegister: boolean;
  fromToLanguage: string;
  country: string;
  nativeLanguageName: string;
  nativeLanguageCode: string;
};

export type OrganizationDetails = {
  id: string;
  dealId: string;
  creatorId: string;
  organizationName: string;
  state: string;
  cityOrDistrict: string;
  country: string;
  isAllowedToRegister: boolean;
  languagePreferences: LanguagePreferences;
};

export type GroupDetails = {
  isAllowedToRegister: boolean;
  groupName: string;
  teacherName: string;
  fromToLanguage: string;
  nativeLanguage: string;
};

export type GroupStudents = StudentsRegisteredResponse[];

export type AdminOrganizationDetails = {
  organizationName: string;
  state: string;
  cityOrDistrict: string;
  country: string;
};

export type OrganizationInviteDetails = {
  organizationId: string;
  organizationName: string;
  invitationLinkForTeachers: string;
};

export type RegisteredTeachersData = {
  teachers: RegisteredTeacherDetails[];
  invitationLink: string;
};

export type RegisteredTeacherDetails = {
  firstName: string;
  lastName: string;
  groupsNumber: number;
  totalStudents: number;
};

/** Level control settings shared by class create/update payloads. See ELL-7727. */
export type ClassLevelControlSettings = {
  placementTestRequired: boolean;
  defaultStartingLevel: string | null;
  allowIndividualAdvancement: boolean;
};

export type BaseGroupDetails = {
  groupName: string;
  grade: string;
  /** @deprecated use placementTestRequired instead. Kept for backward compatibility. */
  initalLevelTest?: boolean;
  classCode?: string;
} & Partial<ClassLevelControlSettings>;

export type GoogleClassAction = 'create' | 'update' | 'delete';

export type GoogleClassOperation = 'add' | 'sync' | 'delete';

export type EmptyModalState = {
  show: boolean;
  hasFilteredClasses: boolean;
};

export type BaseGoogleCourses = {
  id: string;
  name: string;
  section?: string;
  room?: string;
  deletionRequired?: boolean;
};

export type SyncGoogleCourses = {
  id: string;
  action: string;
  name: string;
};

export type CreateGroupDetails = BaseGroupDetails & {};

export type EditGroupDetails = BaseGroupDetails & {
  groupId: string;
};

export type CreateUserDetails = {
  firstName: string;
  lastName: string;
  userId: string; // USER ID FROM COGNITO
  email: string;
};

export type CreateClassCodeUserDetails = {
  firstName: string;
  lastName: string;
  username: string;
  classCode: string;
  userId: string;
};

export type CreateStudentData = {
  firstName: string;
  lastName: string;
  email: string;
};

export type CreateCsvStudentsData = {
  registeredStudents: StudentsResponse[];
  unregisteredStudents: StudentsResponse[];
};

export type StudentsResponse = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  error: string;
};

export enum UserStatusEnum {
  INACTIVE = 'INACTIVE',
  LEVEL_TEST_INCOMPLETE = 'LEVEL_TEST_INCOMPLETE',
  ACTIVE = 'ACTIVE',
  RESET_PASSWORD = 'RESET_PASSWORD',
  LEVEL_UP = 'LEVEL_UP',
  LEVEL_DOWN = 'LEVEL_DOWN',
  LEVEL_COMPLETED_BLOCKED = 'LEVEL_COMPLETED_BLOCKED',
}

export type StudentsRegisteredResponse = {
  studentId: string;
  firstName: string;
  lastName: string;
  username?: string;
  email: string;
  userStatus: UserStatusEnum;
};

export type RegistrationQueryData = {
  dealId: string;
  organizationId: string;
};
